module.exports = "<div class=\"list filternav-list{{::vm.isLink ? ' filternav-list-standard' : ''}}\"> <fb-tree-view-item change-filters=::vm.onChangeFilters($event) category=vm.category level=vm.level is-link=::vm.isLink ng-repeat=\"item in vm.items|limitTo:vm.limit\" item=item ng-class=\"'lvl' + vm.level\"> </fb-tree-view-item> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/common/tree-view.html
// module id = 589
// module chunks = 0